

































import Component from 'vue-class-component';
import BaseComponent from '../BaseComponent';

@Component({
  props: {
    value: {
      default: null,
    },
    returnDateTimeString: {
      type: Boolean,
      default: false,
    },
  },
})
export default class DateInput extends BaseComponent {
  day = '01';
  month = '01';
  year = '2020';

  mounted() {
    this.parseValue();
    this.updateValue();
    this.$watch(
      () => this.$props.value,
      () => {
        this.parseValue();
      }
    );
  }

  parseValue(): void {
    let val = this.$props.value;
    if (!val) {
      val = this.$dayjs();
    } else {
      val = this.$dayjs(val, 'DD/MM/YYYY').isValid()
        ? this.$dayjs(val, 'DD/MM/YYYY')
        : this.$dayjs();
    }

    this.day = val.format('DD');
    this.month = val.format('MM');
    this.year = val.format('YYYY');
  }

  updateValue(): void {
    let toEmit;

    const parsedDate = this.$dayjs(
      `${this.day}/${this.month}/${this.year}`,
      'DD/MM/YYYY'
    ).utc(true);

    if (this.$props.returnDateTimeString) {
      toEmit = parsedDate.isValid() ? parsedDate.toDate() : new Date();
    } else {
      toEmit = parsedDate.isValid() ? parsedDate.format('DD/MM/YYYY') : null;
    }

    this.$emit('input', toEmit);
  }
}
